<template>
  <modal name="crtfPassTermsPopup" :adaptive="true" @before-open="beforeOpen" @opened="opened">
    <div id="crtfPassTermsPopup" class="mobile-popup">
      <div class="popup-header talk re-style">
        <header class="pad_0">
          <h1><a class="logo"></a></h1>
        </header>
        <p class="page-header__big-text mar_b0">
          개인정보 수집 및 이용 동의
        </p>
      </div>
      <div class="popup-body">
        <div class="agree-box">
          <h4 class="title">[개인정보 수집 및 이용 동의]</h4>
          <ol class="list">
            <li class="list__item no-bullet">
              <p>
                <b>1. 수집 및 이용목적</b>
              </p>
            </li>
            <li class="list__item">
              <p>
                중고폰 판매에 따른 본인 확인
              </p>
            </li>
            <li class="list__item">
              <p>
                중고폰 판매에 따른 대금 지급 등 계약의 이행
              </p>
            </li>
            <li class="list__item">
              <p>
                고객상담(고객 불만 접수 및 처리)
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                <b>2. 수집항목</b>
              </p>
            </li>
            <li class="list__item">
              <p>
                본인인증 정보(이름, 생년월일, 성별, 휴대폰번호, 통신사, CI), 은행명, 계좌번호
              </p>
            </li>
            <li class="list__item no-bullet">
              <p>
                <b>3. 보유 및 이용기간</b>
              </p>
            </li>
            <li class="list__item">
              <p>
                <b>거래완료 후 5년 (단, 법령에 따른 보유의 경우 해당 법령에서 정한 기간까지)</b>
              </p>
            </li>
            <li class="list__item bullet-point">
              <p>
                개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의 거부시 서비스 이용이 제한됩니다.
              </p>
            </li>
          </ol>
        </div>
      </div>
      <!-- 하단 버튼 -->
      <div class="popup-footer">
        <div id="regBtnDiv" class="ui-buttons">
          <ul class="ui-buttons__list">
            <li class="ui-buttons__item">
              <button type="button" class="ui-button ui-basic-button" @click="close">
                확인
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'CrtfPassTermsPopup',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    beforeOpen (e) {
    },
    opened () {
      document.body.classList.add('modal-open')
      $('.mscroll').mCustomScrollbar({
        theme: 'dark-thick',
        scrollInertia: 600
      })
    },
    close () {
      this.$modal.hide('crtfPassTermsPopup')
      document.body.classList.remove('modal-open')
    }
  }
}
</script>

<style>
body.modal-open {
  overflow: hidden;
}
</style>
<style scoped>
.mobile-popup {
  position: fixed;
  top: 0;
  left: 50%;
  width: 100vw;
  height: 100vh;
  background: white;
  display: flex;
  flex-direction: column;
  z-index: 1001;
}

/* 헤더 */
.popup-header {
  position: relative;
  padding: 20px 16px 20px;
  background-color: #fff;
}

.popup-title {
  display: block;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  line-height: 1.5;
  word-break: keep-all;
}

.popup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 25px;
  height: 25px;
  border: none;
  border-radius: 50%;
  background-color: #00C4B4;
  color: #ffffff;
  font-weight: bold;
  text-align: center;
  padding: 0;
}

/* 본문 */
.popup-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  font-size: 14px;
  line-height: 1.6;
  -webkit-overflow-scrolling: touch;
  word-break: break-all; /* 단어 중간이라도 줄바꿈 가능 */
  white-space: normal;   /* 기본 줄바꿈 허용 */
}

.clause-title {
  font-weight: bold;
  margin-top: 12px;
  font-size: 15px;
}

/* 하단 버튼 */
.popup-footer {
  padding: 16px;
  background: white;
}

.popup-confirm {
  width: 100%;
  height: 53px;
  padding: 14px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  background-color: #00C4B4;
  color: white;
  border-radius: 8px;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/views/crtfpass/CrtfPassTermsPopup.vue